import classNames from 'classnames';
import DashboardContainer from 'components/foundation/dashboard/DashboardContainer/DashboardContainer';
import { useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import { ClassName } from 'types/ClassName';
import { acquireApolloBatchingDisabled, releaseApolloBatchingDisabled } from 'utils/apollo/batchingScope';
import { t } from 'utils/localize';
import { DashboardSettingsContextProvider } from '../context/DashboardSettingsContext';
import DashboardGrid from '../dashboard-grid/DashboardGrid/DashboardGrid';

interface IDashboardProps {
  className?: ClassName;
}

function Dashboard({ className }: IDashboardProps) {
  const classes = classNames('dashboard', className);

  // Disable Apollo HTTP batching while the dashboard is mounted so each card's request returns
  // independently instead of every card waiting on the slowest query in a shared batch. Acquire during
  // render (once per instance, so it's in place before the cards fire their queries on mount) and
  // release on unmount. The ref guard keeps re-renders from inflating the count.
  const acquiredScope = useRef(false);
  if (!acquiredScope.current) {
    acquiredScope.current = true;
    acquireApolloBatchingDisabled();
  }
  useEffect(() => () => releaseApolloBatchingDisabled(), []);

  return (
    <DashboardContainer className={classes}>
      <Helmet>
        <title>{t('Dashboard')}</title>
      </Helmet>
      <DashboardSettingsContextProvider>
        <DashboardGrid />
      </DashboardSettingsContextProvider>
    </DashboardContainer>
  );
}

export default Dashboard;
